<div class="eos-special-instruction-container">
  <app-panel *ngIf="showInstruction" header="special instructions" [expanded]="true" [hideToggle]="true">
    <div class="eos-special-instruction" slot="body" #divEl></div>
    <span slot="description">View less</span>
  </app-panel>
</div>
